/**
 * SectionRegistry — maps section_type string → React component.
 * Unknown types are silently skipped in DynamicPageRenderer.
 */

import HeroSection          from './sections/HeroSection';
import TextBlockSection     from './sections/TextBlockSection';
import ImageBannerSection   from './sections/ImageBannerSection';
import DividerSection       from './sections/DividerSection';
import StatWidgetsSection   from './sections/StatWidgetsSection';
import DataCardsSection     from './sections/DataCardsSection';
import DataTableSection     from './sections/DataTableSection';
import DataListSection      from './sections/DataListSection';
import DataTimelineSection  from './sections/DataTimelineSection';
import FormBuilderSection   from './sections/FormBuilderSection';
import HtmlCssSection       from './sections/HtmlCssSection';
import PublicPageSection    from './sections/PublicPageSection';
const SectionRegistry = {
  hero:               HeroSection,
  text_block:         TextBlockSection,
  image_banner:       ImageBannerSection,
  divider:            DividerSection,
  stat_widgets:       StatWidgetsSection,
  data_cards:         DataCardsSection,
  data_table:         DataTableSection,
  data_list:          DataListSection,
  data_timeline:      DataTimelineSection,
  // chart_bar and chart_line: deferred to Phase 4 (recharts dependency)
  form_builder:       FormBuilderSection,
  html_css_workspace: HtmlCssSection,
  public_page:        PublicPageSection,
};

export default SectionRegistry;
